export default "__VITE_ASSET__DAZ25rdR__"